/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Style_LabelInputs */

const cs_templates_ai_style_label = /** @type {(inputs: Templates_Ai_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přenos stylu`)
};

const en_templates_ai_style_label = /** @type {(inputs: Templates_Ai_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style transfer`)
};

/**
* | output |
* | --- |
* | "Style transfer" |
*
* @param {Templates_Ai_Style_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_style_label = /** @type {((inputs?: Templates_Ai_Style_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Style_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_style_label(inputs)
	return cs_templates_ai_style_label(inputs)
});